/**
 * Utility functions for CDN URL handling
 */

/**
 * Converts a relative or full image URL to use the CDN when configured.
 * This should be used for all dynamically loaded images from the theme/config.
 * 
 * Uses NEXT_PUBLIC_ASSET_BASE which mirrors the assetPrefix from next.config.mjs.
 * When CDN is enabled, this will be the full CDN URL. When running locally, it will be empty.
 * 
 * @param imageUrl - The image URL from the backend (can be relative or absolute)
 * @returns The CDN-prefixed URL when CDN is enabled, or the original URL for local development
 */
export function getImageURL(imageUrl: string | undefined | null): string {
  if (!imageUrl) return '';
  
  // If the URL is already absolute (starts with http:// or https://), return as-is
  if (imageUrl.startsWith('http://') || imageUrl.startsWith('https://')) {
    return imageUrl;
  }
  
  // For relative URLs, ensure they start with /
  const normalizedUrl = imageUrl.startsWith('/') ? imageUrl : `/${imageUrl}`;
  
  // Get the asset base from environment (empty string when CDN is disabled)
  const assetBase = process.env.NEXT_PUBLIC_ASSET_BASE || '';
  
  // Return the full CDN URL or just the path for local development
  return assetBase ? `${assetBase}${normalizedUrl}` : normalizedUrl;
}
